/** The evals page's own chrome: what it is called, how wide, what floats over what. */

export const EVALS_PAGE_TITLE = "Evals";

/** How many recent runs the case-health matrix shows, newest column last. */
export const MATRIX_RUN_COLUMNS = 12;

/** Shallower than the dashboard's matrix, to keep the dedicated cases page's last column narrow. */
export const CASES_PAGE_RUNS_PER_CASE = 10;

/**
 * Clears `dialog.tsx`'s `z-[1200]`, which the poppers' own `z-50` does not: an
 * unraised dropdown paints behind the dialog and the overlay eats its clicks.
 */
export const POPOVER_IN_DIALOG_Z = "z-[1300]";
